<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>用户充值/提现记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-select v-model="params.queryType" placeholder="请选择账户类型">
          <el-option label="用户账号" value="1"></el-option>
          <el-option label="用户ID" value="0"></el-option>
        </el-select>
        <el-input
          placeholder="请输入内容"
          v-model="params.queryValue"
        ></el-input>
        <el-input
          placeholder="输入地址查询"
          v-model="params.address"
        ></el-input>
        <el-input placeholder="输入TXID" v-model="params.hashCode"></el-input>
        <el-date-picker
          v-model="times"
          type="daterange"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-button type="primary" @click="getBill({ page: 1 })">查询</el-button>
        <el-select
          v-model="params.coinType"
          @change="getBill"
          placeholder="请选择币种"
        >
          <el-option value="">请选择</el-option>
          <el-option
            v-for="item in coinList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="params.type"
          placeholder="请选择账单类型"
          @change="getBill"
        >
          <el-option value="">请选择</el-option>
          <el-option label="充值" value="1"></el-option>
          <el-option label="提现" value="-1"></el-option>
          <el-option label="内部地址提现" value="-2"></el-option>
        </el-select>
      </div>
      <bill-list @refresh="refreshList"></bill-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import BillList from './components/BillList';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Bill',
  data() {
    return {
      times: [],
      params: {
        coinType: '',
        type: '',
        queryType: '0',
        queryValue: '',
        id: '',
        address: '',
        hashCode: ''
      }
    };
  },
  computed: {
    ...mapState('bill', ['coinList', 'pagination']),
    startTime() {
      return this.times ? this.times[0] : '';
    },
    endTime() {
      return this.times ? this.times[1] : '';
    }
  },
  methods: {
    ...mapActions('bill', ['getUserBillList', 'listAllCoin']),
    refreshList(data = {}) {
      this.getBill({
        ...this.params,
        ...this.pagination,
        ...data
      });
    },
    getBill(data) {
      this.getUserBillList({
        startTime: this.startTime,
        endTime: this.endTime,
        ...this.params,
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.listAllCoin();
    this.getBill();
  },
  components: {
    BillList
  }
};
</script>

<style lang="less" scoped></style>
